module.exports = __webpack_public_path__ + "media/recipes/156-42c45d43.png";